import {useTable, useSortBy, useFilters, usePagination, useGlobalFilter} from 'react-table';
import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';
import {Table, Button, Input, Dropdown, Grid} from 'semantic-ui-react';
import {invoicesPageSizes} from '../../../common/constants/lists';
import {Filter, DefaultColumnFilter} from './tableFilters';


export function ManageColorsTable({columnsTable}) {
  const colors = useSelector((state) => state.manageColors.colors);
  const columns = useMemo(() => columnsTable, []);
  const filterTypes = React.useMemo(
    () => ({
      'text': (rows, id, filterValue) => {
        return rows.filter((row) => {
          const rowValue = row.values[id];
          return rowValue != null ?
            String(rowValue)
              .toLowerCase()
              .startsWith(String(filterValue).toLowerCase()) : true;
        });
      },
    }),
    []
  );
  
  const defaultColumn = React.useMemo(
    () => ({
      'Filter': DefaultColumnFilter,
    }),
    []
  );
  
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    nextPage,
    previousPage,
    setPageSize,
    gotoPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    'state': {pageIndex, pageSize},
  } = useTable({
    columns,
    'data': colors,
    'defaultColumn': defaultColumn,
    'initialState': {'pageIndex': 0},
    'filterTypes': filterTypes,
  },
  useFilters,
  useGlobalFilter,
  useSortBy,
  usePagination,
  );

  return (
    <>
      <Table className='interactive' compact striped {...getTableProps()}>
        <Table.Header>
          {headerGroups.map((headerGroup) => (
            <Table.Row key='headers' {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, index) => (
                <Table.HeaderCell
                  key={`title-${index}`}
                  textAlign='center'
                  {...column.getHeaderProps()}
                >
                  {column.render('Header')}
                </Table.HeaderCell>
              ))}
            </Table.Row>
          ))}
          {headerGroups.map((headerGroup) => (
            <Table.Row key='filters' id='filters'>
              {headerGroup.headers.map((column, index) => (
                <Table.HeaderCell
                  key={`filter-${index}`}
                  className={index < 2 ? 'dropdown-header' : ''}
                  textAlign='center'
                >
                  <Filter column={column} />
                </Table.HeaderCell>
              ))}
            </Table.Row>
          ))}
        </Table.Header>
        <Table.Body {...getTableBodyProps()}>
          {!page.length && (
            <Table.Row>
              <Table.Cell colSpan={15} textAlign='center'>
                No hay datos disponibles
              </Table.Cell>
            </Table.Row>
          )}
          {page.length > 0 &&
            page.map((row, i) => {
              prepareRow(row);
              return (
                <Table.Row key={i} {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <Table.Cell textAlign='center' {...cell.getCellProps()}>
                        {cell.render('Cell')}
                      </Table.Cell>
                    );
                  })}
                </Table.Row>
              );
            })}
        </Table.Body>
      </Table>
      {page.length > 0 && (
        <Grid className='pagination'>
          <Grid.Row>
            <Grid.Column width={3} textAlign='left'>
              <Button
                className='navigation-button'
                onClick={() => previousPage()}
                disabled={!canPreviousPage}
                content='Anterior'
              />
            </Grid.Column>
            <Grid.Column width={5}>
              <span>páginas </span>
              <span>
                <Input
                  className='pages-input'
                  type='number'
                  value={pageIndex + 1}
                  min='1'
                  max={pageOptions.length}
                  onChange={(e, {value}) => {
                    const page = value ? Number(value) - 1 : 0;
                    if (page < 1 || page > pageOptions.length) {
                      e.target.value = 1;
                    }
                    gotoPage(page);
                  }}
                />
              </span>{' '}
              <span>de {pageOptions.length}</span>
            </Grid.Column>
            <Grid.Column width={5}>
              <Dropdown
                className='page-sizes-selection'
                selection
                upward
                compact
                value={pageSize}
                options={invoicesPageSizes}
                onChange={(e, {value}) => {
                  setPageSize(Number(value));
                }}
              />
              <span> filas</span>
            </Grid.Column>
            <Grid.Column width={3} textAlign='right'>
              <Button
                className='navigation-button'
                onClick={() => nextPage()}
                disabled={!canNextPage}
                content='Siguiente'
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      )}
    </>
  );
}
export default ManageColorsTable;
